// Function to safely decode base64 string
export const safeAtob = (str: string) => {
  try {
    return atob(str);
  } catch (error) {
    console.error("Error decoding base64 string:", error);
    return null; // Return null or handle the error accordingly
  }
};
